import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import './DlUnitEdit.scss';
import { getUnit, saveUnit } from "./../../actions";
import FileUpload from './FileUpload';
import StatFileLink from '../StatFileLink';
import DlUnit from '../../models/DlUnit';
import DlUnitSingleNav from './DlUnitSingleNav';

const mapStateToProps = (state) => ({
  dlUnitId: state.dlUnit.dlUnitId,
  dlUnit: state.dlUnit.dlUnit
});
  
const mapDispatchToProps = (dispatch) => ({
  getUnit: (id) => dispatch(getUnit(id)),
  saveUnit: (payload) => dispatch(saveUnit(payload)),
});

const DlUnitScanUpd = ({ match, getUnit, saveUnit, dlUnit, dlUnitId }) => {
  let [scans, scansSet] = useState([]);
  const itemId = ( 'itemId' in match.params ? match.params.itemId : '' );
  let scansStart = dlUnit.hasOwnProperty('scans') && dlUnit.scans !== '' ? dlUnit.scans : [];

  useEffect(function() {
    if (itemId!=='') {
      getUnit(itemId);
    }  
  }, [itemId]);

  useEffect(function() {
    scansSet(scansStart);      
  }, [scansStart]);

  const saveItem = () => {
    let item = new DlUnit();
    item.obSet(dlUnit);
    item.scans = scans;
    saveUnit({ itemId, item });
  }

  const scanUpAfter = (res, ind) => {
    res = JSON.parse(res);
    let scans2 = scans.slice(0, ind);
    for (let i = 0; i < res.files.length; i++) {
      scans2.push(res.files[i]['filename']);
    }
    scans2 = scans2.concat(scans.slice(ind));
    scansSet(scans2);
  };

  const scanUpOpt = {
    upFoldPath: 'up/dl-unit/scan/' + dlUnit.fold + '/',
    upOnSel: true,
    multi: true,
    // resizeOpt: {
    //   resizeType: 'w_h', 
    //   whMax: 150
    // },

  };

  const deleteItem = (ind) => {
    const scans2 = [...scans];
    scans2.splice(ind, 1);
    scansSet(scans2); 
  };

  let fileUpLi = [<FileUpload fOpt={ scanUpOpt } fUpAfter={ scanUpAfter } fUpAfterPar={ 0 } key={'fu-' + 0} />];
  for (let i = 0; i < scans.length; i++) {
    fileUpLi.push(<StatFileLink fold={ 'dl-unit/scan/' + dlUnit.fold } fNam={ scans[i] } nam={ scans[i] } key={'fl-' + i} addOpt={{ lStyle: { marginRight: '3%' } }}  />);
    fileUpLi.push(<span onClick={() => deleteItem(i)} style={{ cursor: 'pointer', marginRight: '5%' }} key={'fd-' + i}>x</span>);
    fileUpLi.push(<FileUpload fOpt={ scanUpOpt } fUpAfter={ scanUpAfter } fUpAfterPar={ i + 1 } key={'fu-' + (i + 1)} />);    
  }

  return (
    <Container
      sm={{ span: 12 }}
      md={{ span: 12 }}
      lg={{ span: 12 }}
      xl={{ span: 12 }}
    >
      <DlUnitSingleNav item={ dlUnit } />
      <Row style={{ marginTop: '1em' }} >
        { fileUpLi }
      </Row>      
      <Row className="a-save-p">
          <button onClick={()=>saveItem()}>OK</button>
      </Row>
    </Container>
  );

}

export default connect(mapStateToProps, mapDispatchToProps)(DlUnitScanUpd);
